import { FC } from 'react'

import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import InfoIcon from 'src/Assets/Svg/common/info.svg?react'
import { variables } from 'src/Styled/variables'
import {
  CampaignPlatformTypeEnum,
  CampaignStatusEnum,
} from 'src/Types/campaigns'
import { TikTokTrackSearchErrorEnum } from 'src/Redux/tiktokTrack-process/utils'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { ExistingTikTokCampaign } from 'src/Redux/tiktokTrack-process'
import { useGetCampaignTiktokDetailsQuery } from 'src/Redux/campaignTiktokDetailsApi'

import { HowToGetTrackUrl } from '../TrackSearch/Components/HowToGetTrackUrl'
import { TrackSearchError } from '../TrackSearchError'

import { useTikTokTrackErrorData } from './useTikTokTrackErrorData'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

const Title = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const ImagesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;

  img {
    width: 240px;
    height: auto;
  }
`

interface TikTokTrackSearchErrorProps {
  error: TikTokTrackSearchErrorEnum | string
  existingTikTokCampaign?: ExistingTikTokCampaign | null
}

export const TikTokTrackSearchError: FC<TikTokTrackSearchErrorProps> = ({
  error,
  existingTikTokCampaign,
}) => {
  const navigate = useNavigate()

  const campaignId = existingTikTokCampaign?.id
  const { data: campaignDetails, isFetching } =
    useGetCampaignTiktokDetailsQuery(campaignId ? String(campaignId) : '', {
      skip: !campaignId,
    })

  const onStartCampaignClick = (): void => {
    navigate(`${ArtistRoutesEnum.TiktokSchedule}/${existingTikTokCampaign?.id}`)
  }

  const onDetailsClick = (): void => {
    navigate(`${ArtistRoutesEnum.TiktokDetails}/${existingTikTokCampaign?.id}`)
  }

  const { visualError, campaignErrorElement } = useTikTokTrackErrorData({
    error,
    isFetching,
    onStartCampaignClick,
    onDetailsClick,
    status: campaignDetails?.status as unknown as CampaignStatusEnum,
    campaign: existingTikTokCampaign,
  })

  if (campaignErrorElement) {
    return campaignErrorElement
  }

  if (!visualError) {
    return null
  }

  if (typeof visualError === 'string') {
    return <TrackSearchError>{visualError}</TrackSearchError>
  }

  return (
    <Container>
      <TitleContainer>
        <InfoIcon />
        <Title>{visualError.title}</Title>
      </TitleContainer>

      <ImagesWrapper>
        {visualError.images.map((image) => (
          <img key={image} src={image} alt='error' />
        ))}
      </ImagesWrapper>

      <HowToGetTrackUrl platform={CampaignPlatformTypeEnum.TIKTOK} />
    </Container>
  )
}
